import GoogleMap from './GoogleMap';
import AddressInput from './AddressInput';
import './styles.less';
export default {
    GoogleMap,
    AddressInput,
}